import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpNewService } from './application/http-new.service';
import { AuthService } from './auth.service';
import { dateToText } from '../components/application/global.function';
import {
    ILabResearchChild,
    ILabSize,
    IResponseGetListResearch,
    IResponseLabOrders,
    TResponseGetListResearch,
} from '../interfaces/lab.interfaces';
import { IResearchFileList } from '../interfaces/laboratory-services.interfaces';

@Injectable({
    providedIn: 'root',
})
export class LabService {
    public constructor(
        private httpNew: HttpNewService,
        private auth: AuthService,
    ) {}
    /**
     *
     * @param begin
     * @param end
     * @returns {Observable<any>}
     */
    public getLaboratoryOrderSize(
        beginDate: Date | null,
        endDate: Date | null,
    ): Observable<ILabSize> {
        const param = new Array();

        if (beginDate) {
            param.push('beginDate=' + dateToText(new Date(beginDate)));
        }

        if (endDate) {
            param.push('endDate=' + dateToText(new Date(endDate)));
        }

        const pr = param.join('&');
        const url = '/labs/orders/size?' + pr;
        return this.httpNew.get<ILabSize>(url, null);
    }

    /**
     *
     * @param begin
     * @param end
     * @param orderBy = acs / desc
     * @returns {Observable<any>}
     */
    public getLaboratoryOrderList(
        beginDate: Date | null,
        endDate: Date | null,
        pStart?: number,
        pEnd?: number,
        orderBy: string = 'acs',
    ): Observable<IResponseLabOrders[]> {
        const param = new Array();

        param.push('orderBy=' + orderBy);

        if (beginDate) {
            param.push('beginDate=' + dateToText(new Date(beginDate)));
        }

        if (endDate) {
            param.push('endDate=' + dateToText(new Date(endDate)));
        }
        if (pStart && pEnd) {
            param.push('start=' + pStart);
            param.push('end=' + pEnd);
        }

        const pr = param.join('&');
        //TomCat    return this.httpNew.get(`/api/patient/${null}/laborder?beginDate=${begin}&endDate=${end}` , null)
        const url = '/labs/orders?' + pr;
        return this.httpNew.get<Array<IResponseLabOrders>>(url, null);
    }

    // с квери для списка лабы
    public getLaboratoryResearch(
        researchid: number,
    ): Observable<TResponseGetListResearch> {
        const param = new Array();
        param.push('researchId=' + researchid);
        const pr = param.join('&');
        // console.log(pr);
        const url = '/labs/research?' + pr;
        return this.httpNew.get<TResponseGetListResearch>(url, null);
    }

    // с парамсами для чайлд
    public getLaboratoryChildResearch(
        researchId: number | null,
        researchChildId?: number,
        type?: string,
    ): Observable<Array<ILabResearchChild>> {
        const params = [];
        if (researchChildId) params.push(researchChildId);
        if (type) params.push(type);
        return this.httpNew.get<Array<ILabResearchChild>>(
            '/labs/research/' + params.join('/'),
        );
    }
    /** Пример вывода! "data":[{"srvText":"АЛТ","dist":" ","measur":"АЛТ","unit":" ","result":"12.0","norm":null,"text":"12","normNote":null,"notes":" ","testNotes":null,"headermark":0,"resDisplayOrder":null,"displayTitle":null,"restype":0,"protoSort":0,"normText":null,"testId":795073220902,"seqno":2,"resultdate":"03.07.2024 16:43","specimenText":"Сыворотка Nlab","regdate":"2024-07-03T13:20:00.000Z"},{"srvText":"АСТ","dist":" ","measur":"АСТ","unit":" ","result":"9.0","norm":null,"text":"9","normNote":null,"notes":" ","testNotes":null,"headermark":0,"resDisplayOrder":null,"displayTitle":null,"restype":0,"protoSort":0,"normText":null,"testId":795073220903,"seqno":3,"resultdate":"03.07.2024 16:43","specimenText":"Сыворотка Nlab","regdate":"2024-07-03T13:20:00.000Z"}] */

    // Видимо больше не актуально
    // public getResearchFileList(
    //     researchid: number
    // ): Observable<IResearchFileList[]> {
    //     return this.httpNew.get(
    //         `/labs/research/files?researchid=${researchid}`,
    //         null
    //     );
    // }
}
